import * as colors from './colors';

const createLinearGradient = (colors: { color: string; position?: string }[], direction: string): string => {
  const colorStops = colors.map(({ color, position }) => (position ? `${color} ${position}` : color)).join(', ');

  return `linear-gradient(${direction}, ${colorStops})`;
};

type ColorTokens = {
  [key: string]: string;
};

type GradientDefinition = {
  colors: { color: string; position?: string }[];
  direction: string;
};

const transformColors = (colors: { [key: string]: string | GradientDefinition }): ColorTokens => {
  return Object.keys(colors).reduce((acc, key) => {
    const value = colors[key];
    if (typeof value === 'object' && 'colors' in value) {
      acc[key] = createLinearGradient(value.colors, value.direction);
    } else {
      acc[key] = value as string;
    }
    return acc;
  }, {} as ColorTokens);
};

const colorTokens = transformColors(colors);

export default colorTokens;
